import dayjs from "@forento/core/utilities/dayjs"

export type VideoUploadProgress = { status: "uploading"; progress: number } | { status: "failed" | "completed" }

export async function startVideoUpload(args: {
	file: File
	bunnyVideoId: string
	libraryId: string
	signature: { value: string; expirationDate: Date }
	onProgress: (progress: VideoUploadProgress) => void
}): Promise<void> {
	args.onProgress({ status: "uploading", progress: 0 })

	const { Upload } = await import("tus-js-client")
	const upload = new Upload(args.file, {
		endpoint: "https://video.bunnycdn.com/tusupload",
		retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
		headers: {
			AuthorizationSignature: args.signature.value,
			AuthorizationExpire: dayjs(args.signature.expirationDate).unix().toString(),
			VideoId: args.bunnyVideoId,
			LibraryId: args.libraryId,
		},
		metadata: { filetype: args.file.type },
		onError(error) {
			console.error(error)
			args.onProgress({ status: "failed" })
		},
		onProgress(bytesUploaded, bytesTotal) {
			args.onProgress({ status: "uploading", progress: bytesUploaded / bytesTotal })
		},
		onSuccess() {
			args.onProgress({ status: "completed" })
		},
	})

	const previousUploads = await upload.findPreviousUploads()
	if (previousUploads.length > 0) {
		upload.resumeFromPreviousUpload(previousUploads[0])
	}
	upload.start()
}
